import { CheckCircle, Clock } from "lucide-react";

const VerificationArea = ({ label, verified }) => {
  const StatusIcon = verified ? CheckCircle : Clock;
  
  return (
    <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <StatusIcon className={`w-5 h-5 ${verified ? 'text-green-500' : 'text-yellow-500'}`} />
    </div>
  );
};

export default VerificationArea;